import React, { useEffect, useRef, useState } from 'react';
import { FiMenu } from 'react-icons/fi';
import { IoMdClose } from 'react-icons/io';
import styles from '../css/modules/HamburgerMenu.module.css';

/*
 * Nawigacja glowna. Kolejnosc odzwierciedla wage stron: najpierw uslugi,
 * potem cennik i zaufanie, na koncu poradnik.
 *
 * Dwie decyzje pod katem indeksacji (spec sekcje 2 i 16):
 *  - <nav> renderujemy ZAWSZE, a zamkniete menu chowamy stylami. Wczesniej
 *    linki powstawaly dopiero po kliknieciu, wiec w zrodle strony nie bylo
 *    ani jednego odnosnika nawigacyjnego.
 *  - zwykle <a href> zamiast <Link>: prerender zapisuje wtedy do statycznego
 *    HTML-a pelne, przechodzalne adresy.
 */

const LINKI = [
  { href: '/kwestionariusz-sensomotoryczny/', text: 'Wypełnij kwestionariusz o dziecku', cta: true },
  { href: '/diagnoza-sensoryczna-olsztyn/', text: 'Diagnoza sensoryczna Olsztyn' },
  { href: '/terapia-integracji-sensorycznej-olsztyn/', text: 'Terapia integracji sensorycznej' },
  { href: '/cennik/', text: 'Cennik' },
  { href: '/o-mnie/', text: 'O mnie' },
  { href: '/kontakt/', text: 'Kontakt' },
  { href: '/terapia-reki/', text: 'Terapia ręki' },
  { href: '/trening-umiejetnosci-spolecznych/', text: 'Trening Umiejętności Społecznych' },
  { href: '/zaburzenia-niemowlat/', text: 'Zaburzenia u niemowląt' },
  { href: '/kiedy-do-terapeuty/', text: 'Kiedy do terapeuty?' },
  { href: '/test-sensomotoryczny/', text: 'Test sensomotoryczny' },
  { href: '/krzyzowki/', text: 'Krzyżówki sensoryczne' },
  { href: '/faq/', text: 'FAQ' },
  { href: '/poradnie-psychologiczne/', text: 'Poradnie psychologiczno-pedagogiczne' },
  { href: '/integracja-sensoryczna/', text: 'Artykuły o integracji sensorycznej' },
];

const HamburgerMenu = () => {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);
  const btnRef = useRef(null);

  const toggleMenu = () => setIsOpen((v) => !v);
  const closeMenu = () => setIsOpen(false);

  // zamknij klikając poza i klawiszem ESC
  useEffect(() => {
    if (!isOpen) return undefined;
    const onClickOutside = (e) => {
      if (
        menuRef.current &&
        !menuRef.current.contains(e.target) &&
        btnRef.current &&
        !btnRef.current.contains(e.target)
      )
        closeMenu();
    };
    const onEsc = (e) => {
      if (e.key === 'Escape') closeMenu();
    };

    document.addEventListener('mousedown', onClickOutside);
    document.addEventListener('keyup', onEsc);
    return () => {
      document.removeEventListener('mousedown', onClickOutside);
      document.removeEventListener('keyup', onEsc);
    };
  }, [isOpen]);

  return (
    <div className={styles.hamburgerMenu}>
      <button
        ref={btnRef}
        onClick={toggleMenu}
        className={styles.menuIcon}
        aria-label={isOpen ? 'Zamknij menu' : 'Otwórz menu'}
        aria-expanded={isOpen}
        aria-controls="hamburger-popover"
      >
        {isOpen ? <IoMdClose size={30} /> : <FiMenu size={30} />}
      </button>

      <div
        id="hamburger-popover"
        ref={menuRef}
        className={`${styles.menuContent} ${isOpen ? styles.menuOpen : styles.menuClosed}`}
      >
        <nav className={styles.menuList} aria-label="Menu główne">
          {LINKI.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className={styles.menuText}
              onClick={closeMenu}
              data-cta={l.cta ? 'kwestionariusz' : undefined}
              data-cta-location={l.cta ? 'menu' : undefined}
            >
              {l.text}
            </a>
          ))}
        </nav>
      </div>
    </div>
  );
};

export default HamburgerMenu;
